// extracted by mini-css-extract-plugin
module.exports = {"span":"Span-module--span--ztn9g"};